import { slackAuthLinkGetAsyncSlice } from './get';

export const { requestGetSlackAuthLink, resetGetSlackAuthLink } = slackAuthLinkGetAsyncSlice.asyncActionCreators;
